'use client';
import Image from '@repo/ui/src/components/Image/New';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ButtonStyleEnum, ButtonIconEnum } from '@repo/ui/src/enums/shared-enums';
import { MediaType } from '@repo/ui/src/types/image';
import { MetaProps } from '@repo/ui/src/types';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { useIsSM } from '@repo/ui/src/utils/useMediaQuery';

interface AuthorCardProps {
  _meta: MetaProps;
  name?: string;
  avatar?: MediaType;
  featuredQuote?: string;
  heading?: string;
  link?: string;
  linkLabel?: string;
}

const AuthorCard = ({
  _meta,
  name,
  avatar,
  featuredQuote,
  heading,
  link,
  linkLabel,
}: AuthorCardProps) => {
  const isSM = useIsSM();

  const buttons = [
    {
      link: { link: _meta.deliveryKey, label: linkLabel, displayName: link },
      style: ButtonStyleEnum.Text,
      icon: ButtonIconEnum.Skewer,
    },
  ];
  const imgUrl = buildImageSrc(avatar, isSM ? 700 : 600, isSM ? 9 : 1, isSM ? 10 : 1);

  return (
    <div className="flex flex-wrap h-full">
      <div className="relative w-full aspect-video sm:aspect-none sm:w-1/2 sm:flex-1">
        <Image src={imgUrl} alt={name || ''} fill className="object-cover" priority />
      </div>
      <div className="w-full sm:w-1/2">
        <div className="p-4 md:p-gutterLG flex flex-col justify-center md:max-w-[75%]">
          <ToutContent
            divider
            align="left"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            heading={name}
            headingStyleVariant="h2"
            lilHeading={heading}
            lineClamp={4}
            description={featuredQuote ? `"${featuredQuote}"` : undefined}
            buttons={buttons}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;
